import React, { useState } from 'react'
import './css/header.css';
import logo from './image/2logoiria.jpg';
import { Link } from "react-router-dom";

export const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div>
            <header className="md:px-10 px-5 bg-gradient-to-r from-gray-900 to-indigo-900 flex flex-wrap items-center md:py-0 py-2 shadow-lg sticky top-0 z-50">

                <div className="flex-1 flex justify-between items-center">
                    <Link to="/" className="cursor-pointer">
                        <div className="w-20 h-20">
                            <img src={logo} alt="logo" className="rounded-lg" />
                        </div>
                    </Link>
                </div>

                <button
                    className="cursor-pointer md:hidden block text-white"
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <svg className="fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20">
                        <title>menu</title>
                        <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                    </svg>
                </button>

                <div className={`${menuOpen ? 'block' : 'hidden'} md:flex md:items-center md:w-auto w-full`} id="menu">
                    <nav>
                        <ul className="flex flex-col md:flex-row md:gap-6 text-base text-gray-200 pt-4 md:pt-0 pb-3 md:pb-0">
                            <li><Link className="py-2 px-3 text-base font-medium block border-b-2 border-transparent hover:border-indigo-400 hover:text-white transition-colors" to="/">Home</Link></li>
                            <li><Link className="py-2 px-3 text-base font-medium block border-b-2 border-transparent hover:border-indigo-400 hover:text-white transition-colors" to="/#services">Services</Link></li>
                            <li><Link className="py-2 px-3 text-base font-medium block border-b-2 border-transparent hover:border-indigo-400 hover:text-white transition-colors" to="/AU">About Us</Link></li>
                            <li>
                                <Link
                                    className="ml-2 py-2 px-5 text-base font-semibold bg-indigo-600 hover:bg-indigo-500 text-white rounded-full transition-colors block text-center"
                                    to="/AU"
                                >
                                    Contact Us
                                </Link>
                            </li>
                        </ul>
                    </nav>
                </div>

            </header>
        </div>
    )
}
